import React from 'react';
import GenericExplanation from 'client/QuestionTypes/common/V2/GenericExplanation';

export default function FreeResponseExplanation(props) {
  return <GenericExplanation {...props} hideResultIndicatorBar />;
}
